import { escapeRegExp } from "./escape";

const MARKDOWN_BOLDS = ["**", "__"];
const [MARKDOWN_BOLD] = MARKDOWN_BOLDS;
const MARKDOWN_ITALIC = "_";
const MARKDOWN_STRIKETHROUGH = "~";
const MARKDOWN_QUOTE = ">";
const MARKDOWN_BLOCK_CODE = "```";
const MARKDOWN_BLOCKS = [MARKDOWN_QUOTE, MARKDOWN_BLOCK_CODE];

type MarkdownLike = string | null | undefined;

/**
 * Beware: This method may need additions to support all block markdowns
 */
function startsWithBlockMarkdown(item: MarkdownLike): boolean {
    return MARKDOWN_BLOCKS.some(block => item?.startsWith(block));
}

function boldenMarkdown(item: MarkdownLike): MarkdownLike {
    if (!isFilled(item)) {
        return item;
    }

    return `${MARKDOWN_BOLD}${item}${MARKDOWN_BOLD}`;
}

/**
 * Adds or removes markdown formatting based on a delimiter.
 *
 * Example:
 * - `toggleMarkdownFormatting("Hello", "**")` returns `**Hello**`
 * - `toggleMarkdownFormatting("**Hello**", "**")` returns `Hello`
 */
function toggleMarkdownFormatting(text: string, delimiter: string): string {
    const escapedDelimiter = escapeRegExp(delimiter);
    const regex = new RegExp(`${escapedDelimiter}(.*?)${escapedDelimiter}`);
    const match = text.match(regex);
    if (match) {
        return text.replace(regex, "$1");
    }

    return `${delimiter}${text}${delimiter}`;
}

function isFilled(item: MarkdownLike): item is string {
    return item !== null && item !== undefined && !!item.length;
}

export {
    MARKDOWN_BOLD,
    MARKDOWN_ITALIC,
    MARKDOWN_STRIKETHROUGH,
    toggleMarkdownFormatting,
    startsWithBlockMarkdown,
    boldenMarkdown
};
